<!-- Онбординг -->
<template>
<div class="onboarding-container">
    <Popup :show="show_popup_reminder" v-on:closeEvent="close_popup_reminder">
        <div class="popup-container">
            <div class="popup">
                <div class="content">
                    <div class="input-field">
                        <div class="text1">Înregistrează-te <br>la lecția de probă</div>
                        <div class="text2">Selectează din calendar și<br>înregistrează-te la data și ora potrivită</div>
                        <button class="second-button">Înscrie-te</button>
                    </div>
                </div>
            </div>
        </div>
    </Popup>
    <Popup :show="show_popup_beggining" v-on:closeEvent="close_popup_beggining">
        <div class="popup-container">
            <div class="popup" id="popup-1">
                <div class="content">
                    <div class="input-field">
                        <div class="text1">Lecția a început</div>
                    <div class="cronometer">
                        <img src="@/assets/img/chronometer.png" alt="#">
                    </div>
                    <button class="second-button">Intră în clasă</button>
                </div>
            </div>
            </div>
        </div>
    </Popup>
    
    
     <div class="white_container">
        <h2 class="b5_text">Cum ne pregătim</h2>
        <div class="rectangle5_white">
            <div class="into">
                <div class="double_box" >
                    <div class="before_rect" style="margin-bottom: 16px;">
                        <img src="@/assets/img/pencil.png" alt="#" class="pencil">
                        <div>
                            <h4 class="memorie_date">Rețineți data lecției</h4>
                            <p class="verifi">Verificați dacă veți putea fi prezent cu <br>
                                copilul la ora indicată. Fixați data în <br>
                                calendar.
                            </p>
                        </div>
                    </div>
                    <div class="before_rect">
                        <img src="@/assets/img/clock.png" alt="#" class="pencil">
                        <div>
                            <h4 class="memorie_date">Vă sunăm prealabil</h4>
                            <p class="verifi">Cu 10 minute înainte vom confirma că<br>părintele va fi prezent la lecție. Aceasta<br>este cerința legii.</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="before_rect" style="margin-bottom: 16px;">
                        <img src="@/assets/img/webcam.png" alt="#" class="pencil">
                        <div>
                            <h4 class="memorie_date">Verificați echipamentul</h4>
                            <p class="verifi">Este nevoie de web cameră, microfon și<br>căști la calculator sau laptop.<br>Instalați Zoom accesând următorul link.</p>
                        </div>
                    </div>
                    <div class="before_rect">
                        <img src="@/assets/img/lectie.png" alt="#" class="pencil">
                        <div>
                            <h4 class="memorie_date">Accesăm lecția</h4>
                            <p class="verifi">Accesați de sinestătător butonul Start<br>apel, Vă acomodați, iar metodistul se<br>va alătura.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 

    <div class="white_container">
        <div class="onboarding-content-wrapper">
         <h2>Achitați lecțiile acum și primiți lecții cadou</h2>
            <div class="onboarding-containers">
                <div class="white_container gray">
                    <div class="content-container-wrapper">
                        <div class="lvl_game">
                            <h3>Ridicați nivelul de joc și<br> rezultatele la competiții</h3>
                            <ul>
                                <li>Ajunge pentru 2 luni, câte<br> 2 lecții pe săptămână</li>
                                <li>Este o variantă perfectă, pentru <br> a vedea primele rezultate.</li>
                            </ul>
                        </div>
                        <div class="image-box white">
                            <h1 style="font-style: normal;
                                font-weight: bold;
                                font-size: 24px;
                                line-height: 40px;">16 Lecții</h1>
                            <h2 style="font-style: normal;font-weight: bold;font-size: 16px;line-height: 20px; color: #CF0920;">+2 Lecții cadou !</h2>
                            <img src="@/assets/img/surprise_box.png" alt="" />
                            <input @click="buyFavorite" type="button" value="Cumpără" class="button" :class="{disabled:!product.id}"/>
                        </div>
                    </div>
                </div>
            </div> 
            <h2>După procurare o să ne pregătim pentru lecții</h2>
            <div class="onboarding-containers">
                <div class="white_container gray">
                    <div class="content-container-wrapper">
                        <div class="lvl_game">
                            <ul>
                                <li>O să stabilim nivelul de joc</li>
                                <li>Selectăm pedagog și stabilim orarul</li>
                                <li>Facem cunoștință cu procesul de studii</li>
                            </ul>
                        </div>
                        <div class="image-box">
                            <div class="playtime">
                                <img src="@/assets/img/playtime.png" alt="#" />
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            
                <!-- <div class="rectangle_white">
                <h2 class="b1_text" >Faceți cunoștință cu platforma</h2>
                <p class="b2_text">Este o variantă perfectă, pentru a vedea primele rezultate.</p>
                <div class="img_and_btn">
                <img src="@/assets/img/flat.png" alt="#">
                <input type="button" value="Cumpără" class="button">
                </div>
                </div>  -->
    
             <div class="onboarding-containers">
                <div class="white_container bordered">
                    <div class="container-wrapper">
                        <h2 class="b_abonament_text">Mai mare abonamentul - mai ieftină lecția</h2>
                        <div class="into">
                            <div class="into-rect">
                                <p>8 lecții<span class="discount">Economie de 9%</span></p>
                            </div>
                            <div class="into-rect">
                                <p>16 lecții<span class="discount">Economie de 18%</span></p>
                            </div>
                            <div class="into-rect">
                                <p>32 lecții<span class="discount">Economie de 27%</span></p>
                            </div>
                            <div class="into-rect">
                                <p>64 lecții<span class="discount">Economie de 36%</span></p>
                            </div>
                        </div>
                        <a :href="url_prefix+'/shop'" class="button">{{$t('strings.NAV_STORE')}}</a>
                    </div>
                </div> 
            </div> 
                 <div class="offers shop_container">
                <h2>Alte oferte</h2>
                <div class="offers-list">
                    <div v-for="product of products" class="white_container shop_wrap" :class="[product.ribbon.title !== null?'highlight':null]">
                        <div class="highlight_wrap" v-if="product.ribbon.title !== null">
                            <div class="icon-thumbs-up"></div>
                            <p>{{product.ribbon.title}}</p>
                        </div>
                        <div class="text_wrap">
                            <h2>{{product.qty}}</h2>
                            <h4>{{product.title}}</h4>
                            <p class="old_price" :style="{opacity: product.price.sale !== null?1:0}">{{formatPrice(round2(product.price.regular))}}</p>
                            <p class="price" v-if="product.price.sale !== null">{{formatPrice(round2(product.price.sale))}}</p>
                            <p class="price" v-if="product.price.sale === null">{{formatPrice(round2(product.price.regular))}}</p>
                            <p class="discount_value">{{formatPrice(round2(product.price.unit),product.currency)}}/{{$t("shop.LBL_LECTIE_PRICE")}}</p>
                            <p :style="{opacity: product.price.sale !== null?1:0}" class="discount_value">{{$t("shop.LBL_DISCOUNT_VALUE")}} {{product.price.discount}}%</p>
                            <button v-on:click="startPaymentFlow(product)" class="button" v-html="$t('shop.BTN_MAKE_ORDER')"></button>
                        </div>
                    </div>
                </div> 
                <div class="learn_free">
                    <h1 class="learn_free_text">Învață gratuit</h1>
                    <p class="learn_free_subtext">Invită un prieten și primiți ambii câte 2 lecții<br>cadou la procurarea oricărui abonamet.</p>
                    <div class="learn_free_block">
                        <div class="learn_free_row">
                            <div class="learn_free_box">
                                <img src="@/assets/img/exchange.png" alt="#" class="exchange">
                                <p class="exchange_text">Prietenul procură unul<br> din abonamente</p>
                            </div>
                            <div class="learn_free_box1">
                                <img src="@/assets/img/friend_pay.png" alt="#" class="exchange">
                                <p class="exchange_text">Recomandă unui prieten să <br>învețe șah la Academie</p>
                            </div>
                        </div>
                        <div class="learn_free_row1">
                            <div class="learn_free_box">
                                <img src="@/assets/img/manager.png" alt="#" class="exchange">
                                <p class="exchange_text1">Managerul după procurare revine la prieten și verifică la recomandarea cui a procurat</p>
                            </div>
                            <div class="learn_free_box1">
                                <img src="@/assets/img/open-box.png" alt="#" class="exchange">
                                <p class="exchange_text1">Dacă prietenul e la prima procurare, ambii primiți câte 2 lecții cadou în abonament</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            
            <h2 class="f_antrenamt">Facem antrenamentele la șah<br> interesante și atractive</h2>
            <div class="onboarding-containers">
                <div class="white_container relative-container">
                    <div class="container-wrapper">
                        <div class="into">
                            <div class="into-rect">
                                <p class="rect-text">Livrarea atractivă a materialului, cu<br>pauze recreative, fapte interesante<br>despre șah, exerciții interesante.</p>
                            </div>
                            <div class="into-rect">
                                <p class="rect-text">Metodologie unicală de studii<br> de la Campionii de șah  </p>
                            </div>
                            <div class="into-rect">
                                <p class="rect-text">Studierea pe o platformă de șah <br>interactivă, în care Veți putea<br>interacționa cu profesorul  </p>
                            </div>
                            <div class="into-rect">
                                <p class="rect-text">Feedback sistematic de la<br> profesor pentru părinte </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h2>Metodologie unicală elaborată de către<br><span> liderii pedagogiei șahului din topul mondial</span></h2>
            <div class="consultant-box">
                <div class="consultant-image">
                    <img src="@/assets/img/IonGirnet.png" class="girnetimg" alt="Ion Girnet" />
                </div>
                <div class="consultant-text">
                    <span class="name">Ion Gîrneț</span>
                    <span class="description">Coordonator de proiect sah.md, master în tehnologia <br>antrenamentului sportiv, rating FIDE 1995</span>
                    <p>Cred cu certitudine că jocul de șah asimilat printr-o educație de calitate va contribui semnificativ la identificarea unui 
                        viitor prosper pentru copiii noștri. Am îndrăgit jocul de șah de la vârsta de 5 ani, am participat la multiple turnee,
                         dar vocația mea este dezvoltarea sistemului educațional de șah. Datorită echipei fantastice a Academiei, am elaborat Curriculum ”Șahul”,
                          aprobat de Ministerul Educației al R. Moldova, destinat cât predării jocului, atât și formării pedagogilor. La moment îl implementăm 
                          în platforma interactivă Sah.md care bucură sute de copiii în fiecare zi.
                    </p>
                </div>
            </div>
            <div class="consultant-box">
                <div class="consultant-image">
                    <img src="@/assets/img/kasparov.png" class="kasparovimg" alt="Kkasparov" />
                </div>
                <div class="consultant-text">
                    <span class="name">Consultant - Garry Kasparov</span>
                    <span class="description">Consultant, al 13-lea campion mondial</span>
                    <p>Garry Kasparov, al 13-lea campion mondial, numărul 1 în raitingul mondial pe parcursul a 20 de ani, inclusiv până la încheierea carierei şahistice, fondator al fundaţiilor de şah pe diferite continente, lider al mişcării mondiale privind introducerea şahului în şcoli, promotor al Declaraţiei Scrise nr.0050 a Parlamentului European din 13 martie 2012 privind introducerea programului Şahul în instituţiile de învăţământ în sistemele educaţionale din Uniunea Europeană;</p>
                </div>
            </div>

            <div class="onboarding-containers">
                <div class="interview_block">
                <h2 style="margin-top:72px;">Bilanț intermediar al colaborării<br>
                Academiei Naționale de Șah din Moldova<br>
                și Fundația de șah Kasparov - 2018</h2>
                    <div class="video-interview">
                   <video id="vid"  controls playsinline autoplay muted loop>
                        <source src="@/assets/video/Interview.mp4" type="video/mp4">
                    </video>
                    </div>
                </div>

            </div>

            <div class="onboarding-containers">
                <div class="white_container bordered questions-container">
                    <div class="container-wrapper">
                        <h2>Întrebări frecvente</h2>
                        <div class="questions-box">
                            <QuestionBox>
                                <template v-slot:question>Ce este o lecție introductivă?</template>
                                <template v-slot:answer>Lecția introductivă se ține individual cu un metodist pe site-ul nostru. Pentru copiii de 4-6 ani, durează 25-30 de minute, iar pentru copiii de  7-10 ani în jur la  30-40 de minute.<br/>La lecția introductivă, dvs veți afla nivelul de cunoaștere al copilului. Metodistul Vă va oferi sfaturi despre cum să îmbunătățiți nivelul de cunoaștere, Vă va familiariza cu clasa virtuală și va explica cum decurg lecțiile la Academie. Copilul va îndeplini mai multe sarcini și se va juca.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Se pot desfășura lecțiile de la telefon?</template>
                                <template v-slot:answer>Spre regret, lecțiile se desfășoară doar de pe un calculator cu o cameră web conectată.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Cât costă lecțiile?</template>
                                <template v-slot:answer>Depinde de pachetul de lecție pe care îl cumpărați. În medie, o lecție cu un profesor vorbitor de limbă română costă de la 6,39 Euro.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Cum să ajungi la lecție?</template>
                                <template v-slot:answer>Lecția poate fi desfășurată numai de pe un calculator cu conexiune la internet.<br/>Cu 5-10 minute înainte de începerea lecției, veți primi un apel automat pe telefon. Confirmați că dvs și copilul sunteți gata pentru a începe lecția.<br/>După confirmare, veți primi un link pe email pentru a intra pe platformă. Ea va apărea și în contul dvs personal de pe sah.md. Urmăriți link-ul din mesajul de pe email sau din contul dvs personal și sunteți în lecție!</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Poate fi anulată lecția fără a pierde din cont?</template>
                                <template v-slot:answer>Da. Pentru a reprograma o lecție, anunțați profesorul cu cel puțin 8 ore înainte de începerea lecției. În acest fel, lecția nu va fi luată din contul dvs, iar profesorul va putea să-și reprogrameze orarul.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Nu prea am încredere în învățarea online. Cum se controlează procesul?</template>
                                <template v-slot:answer>Lecțiile sunt monitorizate de metodiști și abordarea este individuală pentru fiecare elev.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Cum voi ști dacă copilul meu progresează?</template>
                                <template v-slot:answer>Profesorul vă trimite un raport despre progresul copilului la fiecare 8 lecții: vă spune cum merg lucrurile, vă oferă recomandări și vă răspunde la întrebări. După finalizarea fiecărui subiect, copilul scrie un test, iar la sfârșitul cursului - examenul final.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>La Academia ni s-a dat tema pentru acasă. Cum să o îndeplinesc?</template>
                                <template v-slot:answer>Întrebați profesorul care a dat tema pentru acasă despre link-ul direct sau numele de utilizator și parola din cabinetul cu exerciții. Introduceți numele de utilizator și parola.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>De ce ar trebui să participe un părinte la lecția introductivă?</template>
                                <template v-slot:answer>Aceasta este o cerință a Legii „Cu privire la datele cu caracter personal”. Putem folosi date despre un copil sub 15 ani numai cu acordul unui părinte sau al unui tutore legal.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Este calculatorul meu potrivit pentru desfășurarea lecțiilor?</template>
                                <template v-slot:answer>Toate lecțiile pentru copii cu vârsta sub 9 ani se țin doar de pe un computer cu prezența obligatorie a unei camere web.<br/>Vă va fi confortabil să studiați dacă calculatorul dvs are:<br/>
                                <ul>
                                    <li>RAM de la 4 GB</li>
                                    <li>Procesorul Intel Core i3 de generația a 4-a</li>
                                    <li>AMD A4-6210 sau și mai bun</li>
                                    <li>Viteza internetului de la 5 Mbps</li>
                                    <li>Browser Google Chrome instalat /Mozilla Firefox /Opera /Yandex sau cea mai recentă versiune a Safari</li>
                                    <li>Aveți căști sau căști cu microfon</li>
                                    <li>O cameră web (lecția nu se va desfășura fără ea).</li>
                                </ul>
                                </template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Trebuie să plătesc pentru o lecție introductivă?</template>
                                <template v-slot:answer>Nu, lecția introductivă este gratuită.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Nu vreau să iau o lecție introductivă. Vreau să mă familiarizez cu site-ul și aplicațiile.</template>
                                <template v-slot:answer>Noi vă  recomandăm să luați o lecție introductivă pentru a afla despre toate caracteristicile platformei și capacitățile școlare. Lecția introductivă este gratuită.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Pot schimba orarul lecțiilor ?</template>
                                <template v-slot:answer>Da. Dvs singuri stabiliți programul și numărul de lecții pe săptămână. Dacă plecați în vacanță, puteți lua o pauză.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Cât durează o lecție obișnuită cu un profesor?</template>
                                <template v-slot:answer>Durata lecției introductive pentru copiii de 4-6 ani este de 25-30 de minute, pentru 7-10 ani - 30-40 de minute.<br/>Durata lecțiilor cu un profesor (după plată) timp de 4-6 ani se desfășoră în jur la 25-30 minute, iar 7-10 ani - 40 minute.<br/></template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Cum putem economisi bani?</template>
                                <template v-slot:answer>Invitați-vă prietenii și obțineți 2 lecții gratuite pentru toți cei care sunt la prima procurare. Prietenii vor primi, de asemenea, 2 lecții gratuite.</template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>De ce sah.md este mai bun decât cursurile offline?</template>
                                <template v-slot:answer><ul>
                                    <li>Economisește timp. Puteți studia în orice zi a săptămânii și în orice moment al zilei și nu pierdeți timpul pe drum.</li>
                                    <li>Este convenabil. Asistența funcționează non-stop.</li>
                                    <li>Este în siguranță. Nu trebuie să pleci într-o zonă necunoscută și să stai în aceeași cameră cu un tutore necunoscut.</li>
                                    <li>Este comod. Nu este nevoie să cumpărați materiale suplimentare. Tot ce aveți nevoie pentru curs este pe platformă. Aveți necesitate doar de internet.</li>
                                </ul></template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Am puțin timp liber. Mă tem că nu voi avea timp să studiez.</template>
                                <template v-slot:answer>Noi ne adaptăm după programul dvs, Veți putea să:<br/><ul>
                                    <li>Studiați în orice moment al zilei - lecțiile la Academie se desfășoară 12/7.</li>
                                    <li>Amânarea lecției este gratuită. Principalul este să-l avertizați pe profesor cu 8 ore înainte de lecție.</li>
                                    <li>Să luați o pauză de la cursuri. Lecțiile vor fi salvate în contul dvs.</li>
                                </ul></template>
                            </QuestionBox>
                            <QuestionBox>
                                <template v-slot:question>Am nevoie de ceva de la birou pentru lecția introductivă?</template>
                                <template v-slot:answer>Nu, un calculator este suficient pentru a studia la Academia noastră.</template>
                            </QuestionBox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <PayMethodPopup
        :show="showPayMethodPopup"
        :selectedProduct="selectedProduct"
        v-on:paymentEvent="paymentFlowRedirectRequest"
        v-on:closeEvent="showPayMethodPopup = !showPayMethodPopup">
    </PayMethodPopup>
    <PaySuccessPopup
        :show="showPaySuccessPopup"
        v-on:closeEvent="showPaySuccessPopup = !showPaySuccessPopup">
    </PaySuccessPopup>
    <PayErrorPopup
        :show="showPayErrorPopup"
        v-on:closeEvent="showPayErrorPopup = !showPayErrorPopup">
    </PayErrorPopup>
</div>
</template>

<script>
    import store from '@/store';
    import { mapGetters, mapActions } from 'vuex';
    import Popup from '@/components/Popup';
    import {todayHowString,rest,formatPrice,decodeHtml} from '@/utils/utils';
    import i18n from '@/i18n';
    import QuestionBox from './QuestionBox.vue';
    import PayMethodPopup from '@/views/pages/shop/popups/PayMethodPopup';
    import PaySuccessPopup from '@/views/pages/shop/popups/PaySuccessPopup';
    import PayErrorPopup from '@/views/pages/shop/popups/PayErrorPopup';

    export default {
        name: 'OnBoarding',
        components: {
            Popup,
            QuestionBox,
            PayMethodPopup,
            PaySuccessPopup,
            PayErrorPopup
        },
        data: function () {
            return {
                show_popup_reminder:false,
                show_popup_beggining:false,
                products:[],
                product:{},
                showPayMethodPopup: false,
                showPaySuccessPopup: false,
                showPayErrorPopup: false,
                selectedProduct: null,
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/get',
            }),
            url_prefix(){
                return (i18n.locale=="ro"?"":"/"+i18n.locale);
            }
        },
        methods: {
            close_popup_reminder(){},
            close_popup_beggining(){},
            get_products(){
                
                store.commit('loading/is', true);
                //Получим товары из предложения
                rest.call("shop_items",{
                    "category_slug":"individual",
                    "currency":this.user.currency
                },"GET").then((response)=>{
                    store.commit('loading/is', false);
                    if(response.status && response.status == "ok" && response.products){
                        this.products = response.products;
                        console.log(response.products);
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                });
                
            },
            get_product(){
                store.commit('loading/is', true);
                //Получим товар для отображения в лендинге
                rest.call("onboarding_product",{
                    "currency":this.user.currency
                },"GET").then((response)=>{
                    store.commit('loading/is', false);
                    if(response.status && response.status == "ok" && response.products){
                        this.product = response.products.shift();
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                });
            },
            formatPrice(value,currency=null){
                currency = currency?currency:this.user.currency;
                return formatPrice(value,currency);
            },
            round2(num) {
                return Math.round(num * 100) / 100;
            },
            buyFavorite(){
                if(this.product.id){
                    this.startPaymentFlow(this.product);
                }
            },
            startPaymentFlow(product) {
                this.selectedProduct = product;
                this.showPayMethodPopup = true;
            },
            /**
             * Заказ товара
             */
            paymentFlowRedirectRequest(paymentInfo){
                store.commit('loading/is', true);
                rest.call("proccess_offer",{
                    "product":paymentInfo.id,
                    "method":paymentInfo.payment_method,
                    "currency":this.user.currency,
                    "rate":paymentInfo.rateEURtoLEI,
                    "qty":paymentInfo.qty,
                    "offer":paymentInfo.offer,
                    "offer_product_id":paymentInfo.offer_product_id,
                },"GET").then((response)=>{
                    store.commit('loading/is', false);
                    if(response.status && response.redirect){
                        window.location.href = decodeHtml(response.redirect);
                        return;
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                });
            }
        },
        mounted(){
            this.get_products();
            this.get_product();
        },
    }
</script>

<style lang="scss" scoped>
.popup-container{
    margin: 0 auto;
}
h2{
    font-size: 32px;
}
.f_antrenamt{
    font-size: 32px;
    line-height: 40px;
    margin-bottom:-25px;
}
.b_abonament_text{
    font-size: 30px;
}
.learn_free_block{
    margin-bottom: 48px;
}
.onboarding-container{
    h2{
        text-align: center;
    }
    .onboarding-content-wrapper{
        padding: 30px 44px;
        .onboarding-containers{
            width:100%;
            margin: 3rem 0rem 2rem;
            .white_container.gray,.white_container.bordered,.white_container.relative-container{
                max-width: 700px;
                margin: 0px auto;
                &:not(.relative-container){
                    padding:2rem;
                }
                .image-box{
                    width: 260px;
                    border-radius: 1rem;
                    margin-left: auto;
                    margin-right: 0;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding:16px;

                    &.white{
                        background: #FFFFFF;
                    }
                    >img{
                        max-width: 72px;
                        width:100%;
                        height: auto;
                        margin:16px 0px;
                    }
                }
                @media (max-width: 800px) {
                 .image-box{
                margin-left: 0px;
                    }
                }
                @media (max-width: 768px){
                    h3{
                        font-size: 18px;
                        line-height: 24px;
                    }
                }
                 /*@media (max-width: 355px){
                    h3{
                        font-size: 18px;
                        line-height: 24px;
                    }
                }*/
            }
            .container-wrapper{
                display: flex;
                flex-direction: column;
                align-items: center;
                .into{
                    width:100%;
                    display: grid;
                    margin:2rem 0px;    
                    grid-template-columns: repeat(2,1fr);
                    grid-gap: 1rem;
                    >.into-rect{
                        border:1px solid #F0F3F8;
                        border-radius: 1rem;
                        text-align: center;
                        >p{
                            font-style: normal;
                            font-weight: bold;
                            font-size: 28px;
                            line-height: 36px; 
                            display: flex;
                            flex-direction: column;
                            padding: 11px;
                            color: rgba(0, 0, 0, 0.8);
                            &.rect-text{
                                font-size: 16px;
                                line-height: 20px;
                                padding: 18px;
                                letter-spacing: 0.5px;
                                font-weight: normal;
                                margin:0px;
                                text-align: left;
                            }
                            >span:nth-child(1){
                                font-size: 18px;
                                line-height: 23px;
                            }

                            >span:nth-child(2){
                                font-style: normal;
                                font-weight: bold;
                                font-size: 24px;
                                line-height: 72px; 
                                padding:10px;
                            }
                            @media (max-width: 390px) {
                                span:nth-child(2){
                                    font-size: 16px;
                                    line-height: 50px;
                                }
                            }
                            span.discount{
                                    color: inherit;
                                    font-size: 18px;
                                    line-height: 21px;
                                    display: inline-block;
                                    width: 100%;
                                    margin: 0px 0px 10px 0px;
                            }
                        }
                        @media (max-width: 390px) {
                            p{
                                font-size: 25px;
                            }
                            

                        }
                    }
                }
                @media (max-width: 1250px) {
	                .into{
		                display: flex;
	                    }
                    }
            }
        }
        .consultant-box{
            width: 100%;
            max-width: 1120px;
            margin: 0 auto;
            padding:0px 100px;
            margin-top:3rem;
            display: flex;
            flex-direction: row;
            .consultant-image{
                width: 100%;
                max-width: 390px;
                img{

                }
            }
            .consultant-text{
	            font-family: FuturaPT;
                padding-left:2rem;
                width: 100%;
                flex: 1;
                span.name{
                    font-style: normal;
                    font-weight: bold;
                    font-size: 24px;
                    line-height: 40px;
                    color: #0B1022;
                    width: 100%;
                    display: inline-block;
                }
                span.description{
                    font-style: normal;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 20px;
                    letter-spacing: 0.5px;
                    color: #595959;
                    width: 100%;
                    display: inline-block;
                }
                >p{
                    font-size: 16px;
                    line-height: 20px;
                    color: #595959;
                    margin-top: 16px;
                }
            }
        }
        
        @media (max-width: 1250px) {
            .consultant-text{
             padding-left: 0px;
            }
         }
         @media (max-width: 1250px) {
         .consultant-box{
             flex-direction: column;
             padding: 0px;
         }
    }
    }
    @media (max-width: 475px) {
    .onboarding-content-wrapper{
        padding: 30px 20px;
        }
    }
    @media (max-width: 320px) {
    .onboarding-content-wrapper{
        padding: 30px 9px;
        }
    }
    .questions-container{
        padding:2rem 0px !important;
        h2{
            padding:0px 2rem;
        }
        .questions-box{
            margin-top:2rem;
            .question-box:last-child{
                border-bottom: 0px;
            }
        }
    }
    .offers{
        width: 100%;
        margin: 0 auto;
        background: #FFFFFF;
        border-radius: 20px;
        display: initial;
        .head-text{
            font-family: FuturaPT;
            font-style: normal;
            font-weight: bold;
            font-size: 32px;
            line-height: 40px;
            letter-spacing: 1px;
            color: #0B1022;
            text-align: center;
        }
        .offers-list{
            display: flex;
            margin: 0 auto;
            width:100%;
            margin-top: 40px;
            flex-wrap: wrap;
            display:grid;
            grid-gap:15px;
            grid-template-columns: repeat(5,1fr);
            .shop_wrap{
                margin:0px;
            }
        }
        @media (max-width: 1420px) {
            .offers-list{
                
            grid-template-columns: repeat(5,1fr);
            }
        }
        @media (max-width: 1140px) {
            .offers-list{
                grid-template-columns: repeat(3,1fr);
            }
        }
        @media (max-width: 800px) {
            .offers-list{
                grid-template-columns: repeat(2,1fr);
            }
        }
        @media (max-width: 425px) {
            .offers-list{
                grid-template-columns: repeat(1,1fr);
                .shop_wrap{
                    margin:0px auto !important;
                }
            }
        }
    }
}
    @media (max-width: 1250px) {
        .double_box{
		    margin-right: 0px;
	    }   
    }
    @media (max-width: 800px) {
        .content-container-wrapper{
            flex-direction: column;
            align-items: center;
        }
    }
    @media (max-width: 768px) {
        
        h2, .f_antrenamt, .b_abonament_text{
            font-size: 34px;
            line-height: 46px;
        }
    }
    @media (max-width: 425px) {
        
        h2, .f_antrenamt, .b_abonament_text{
            font-size: 18px;
            line-height: 24px;
        }
    }
    .video-interview{
        width: 100%;
        max-width: 675px;
        height: 309px;
        margin: 0 auto;
        margin-top: 24px;
        margin-bottom: 48px;
    }
    #vid{
        border-radius: 10px;
        height:100%;
    }
    @media (max-width: 960px) {
        #vid{
            height: 100%;
            width: 100%;
        }
    }
    @media (max-width: 768px) {
        #vid{
            height: 76%;
            width: 100%;
        }
    }
    @media (max-width: 425px) {
        .video-interview{
            height: 135px;
    }
        #vid{
            height: 123%;
            width: 100%;
        }
    }
    @media (max-width: 375px){

        .video-interview{
            height: 116px;
        }
    }
    @media (max-width: 320px){

        .video-interview{
            height: 103px;
        }
    }
</style>